import { useContext } from "react";
import ListingTagsContext from "src/contexts/ListingTags/ListingTagsContext";

const useListingTags = () => useContext(ListingTagsContext);

export default useListingTags;